// extracted by mini-css-extract-plugin
export default {"containerMain":"Manuais_containerMain__ucJNs","modulos":"Manuais_modulos__3WV2U","Glinks":"Manuais_Glinks__ElyBv","links":"Manuais_links__aso4E"};